/**
 * @generated SignedSource<<d7b06e1e8fb0d5bd89a345a9ce7bd88b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainFooterResponseNumber_todo$data = {
  readonly canWrite: boolean;
  readonly id: string;
  readonly isResponseCompleted: boolean;
  readonly response: {
    readonly value?: number | null;
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentType": "TodoEditNewMainFooterResponseNumber_todo";
};
export type TodoEditNewMainFooterResponseNumber_todo$key = {
  readonly " $data"?: TodoEditNewMainFooterResponseNumber_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainFooterResponseNumber_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainFooterResponseNumber_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isResponseCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "TodoResponseNumber",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "64a714d3d49838294d1eb1054cf309a6";

export default node;
